import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Utils from "../../Utils";

const AddNewHotelForm = ({
  open = false,
  onClose = () => {},
  onCreated = () => {},
  brands = [],
  countries = [],
  defaultValues = {},
}) => {
  const MySwal = withReactContent(Swal);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({
    name: "",
    marsha: "",
    brand_id: "",
    country_id: "",
  });

  useEffect(() => {
    if (!open) return;
    setForm({
      name: defaultValues?.name || "",
      marsha: defaultValues?.marsha || "",
      brand_id: defaultValues?.brand_id || "",
      country_id: defaultValues?.country_id || "",
    });
  }, [open, defaultValues]);

  if (!open) return null;

  const updateField = (field) => (event) => {
    const value = event.target.value;
    console.log(`Updating field ${field} with value:`, value);
    setForm((prev) => ({
      ...prev,
      [field]: value, //field === "marsha" ? value.toUpperCase() : value,
    }));
  };

  const submitForm = (event) => {
    event.preventDefault();

    const payload = {
      name: form.name.trim(),
      marsha: form.marsha.trim(), //.toUpperCase(),
      brand_id: Number(form.brand_id),
      country_id: Number(form.country_id),
    };

    if (!payload.name) {
      MySwal.fire("Validation", "Hotel name is required.", "warning");
      return;
    }
    if (!payload.marsha) {
      MySwal.fire("Validation", "Marsha code is required.", "warning");
      return;
    }
    if (!payload.brand_id) {
      MySwal.fire("Validation", "Please select a brand.", "warning");
      return;
    }
    if (!payload.country_id) {
      MySwal.fire("Validation", "Please select a country.", "warning");
      return;
    }

    setSubmitting(true);

    axios
      .post(
        Utils.apiUrl("hr/hotel-access/add-hotel"),
        payload,
        Utils.apiHeaders(),
      )
      .then((res) => {
        if (res.data.success) {
          MySwal.fire(
            "Success",
            res.data.message || "Hotel added successfully.",
            "success",
          );
          onCreated(
            res.data.data || payload,
            res.data.message || "Hotel added successfully.",
          );
          onClose();
          return;
        }
        MySwal.fire(
          "Error",
          res.data.message || "Failed to add hotel.",
          "error",
        );
      })
      .catch(() => {
        MySwal.fire("Error", "Failed to add hotel.", "error");
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-hotel-title"
    >
      <section
        className="relative w-full max-w-2xl rounded-2xl bg-white shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
          <h2
            id="add-hotel-title"
            className="text-lg font-semibold text-gray-900"
          >
            Add New Hotel
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close add new hotel dialog"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form
          onSubmit={submitForm}
          className="grid grid-cols-1 gap-4 p-6 md:grid-cols-2"
        >
          <div className="md:col-span-2">
            <label className="mb-2 block text-sm font-semibold text-gray-700">
              Hotel Name
            </label>
            <input
              type="text"
              value={form.name}
              onChange={updateField("name")}
              placeholder="Name of the Hotel"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">
              Marsha Code
            </label>
            <input
              type="text"
              value={form.marsha}
              maxLength={5}
              onChange={updateField("marsha")}
              placeholder="Marsha code"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
            />
          </div>

          <div className="text-sm text-gray-900 bg-yellow-100 rounded px-3 py-2 flex justify-center items-center">
            If Marsha is unavailable, please add 5 lowercase letters (not in
            capitals).
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">
              Brand
            </label>
            <select
              value={form.brand_id}
              onChange={updateField("brand_id")}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
            >
              <option value="">Select Brand</option>
              {brands.map((brand) => (
                <option key={brand.id} value={brand.id}>
                  {brand.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-gray-700">
              Country
            </label>
            <select
              value={form.country_id}
              onChange={updateField("country_id")}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
            >
              <option value="">Select Country</option>
              {countries.map((country) => (
                <option key={country.id} value={country.id}>
                  {country.name}
                </option>
              ))}
            </select>
          </div>

          <div className="md:col-span-2 flex gap-3 pt-2">
            <button
              type="submit"
              disabled={submitting}
              className="rounded-lg bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {submitting ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              onClick={onClose}
              disabled={submitting}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default AddNewHotelForm;
